import { Box, Typography } from '@mui/material';

export const EmptyState = () => {
    return (
        <Box sx={{ padding: '60px 40px', textAlign: 'center' }}>
            <Typography sx={{ fontSize: '2rem', marginBottom: 2 }}>📋</Typography>
            <Typography sx={{ color: '#64748b', fontSize: '1rem' }}>
                No plan details available
            </Typography>
        </Box>
    );
};
